import PlainTable from './Table';
import { Column } from './components';

type InternalTable = typeof PlainTable;

interface ExportTable extends InternalTable {
  Column: typeof Column;
}

const Table = PlainTable as ExportTable;
Table.Column = Column;

export default Table;
